import { render, staticRenderFns } from "./overviewNavigationBlock.vue?vue&type=template&id=1290df27&"
import script from "./overviewNavigationBlock.vue?vue&type=script&lang=js&"
export * from "./overviewNavigationBlock.vue?vue&type=script&lang=js&"
import style0 from "./overviewNavigationBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports